import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'commitment_level'

export default function CommitmentLevelPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How committed are you to this dream journey?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.commitmentLevel.heading')}
      buttons={[
        {
          text: `🔥 ${t('pages.onboarding.commitmentLevel.options.fullyCommitted')}`,
          value: 'Fully committed - this matters to me',
          subtext: t(
            'pages.onboarding.commitmentLevel.subtexts.fullyCommitted',
          ),
        },
        {
          text: `💪 ${t('pages.onboarding.commitmentLevel.options.prettyCommitted')}`,
          value: 'Pretty committed - willing to try',
          subtext: t(
            'pages.onboarding.commitmentLevel.subtexts.prettyCommitted',
          ),
        },
        {
          text: `🌱 ${t('pages.onboarding.commitmentLevel.options.curious')}`,
          value: 'Curious - lets see how it goes',
          subtext: t('pages.onboarding.commitmentLevel.subtexts.curious'),
        },
        {
          text: `🤷 ${t('pages.onboarding.commitmentLevel.options.justExploring')}`,
          value: 'Just exploring for now',
          subtext: t('pages.onboarding.commitmentLevel.subtexts.justExploring'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
